'use client';

type AuthTokens = {
  access_token: string;
  refresh_token: string;
};

const AUTH_TOKENS_KEY = 'authTokens';

export const setAuthTokens = (tokens: AuthTokens) => {
  localStorage.setItem(AUTH_TOKENS_KEY, JSON.stringify(tokens));
};

export const getAuthTokens = (): AuthTokens | null => {
  try {
    const data = localStorage.getItem(AUTH_TOKENS_KEY);

    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const removeAuthTokens = () => {
  localStorage.removeItem(AUTH_TOKENS_KEY);
};
